import React from 'react';
import ReactDOM from 'react-dom/client';
import '@tencent/tea-component/dist/tea.css';
import './index.css';
import 'swiper/css/bundle';
import App from '@/App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as Element);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
reportWebVitals();
